import React, { useCallback, useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import { defineMessages, FormattedMessage, useIntl } from "react-intl";
import styled from "styled-components";
import swal from "sweetalert";
import { useUserAuthInfo } from "../../../../lib/auth";
import { useApiClient } from "../../../../lib/http";
import SelectGroup from "../../../witadmin/CRUD/Common/SelectGroup";
import ContentWrapper from "../../Layout/ContentWrapper";
import { Payment } from "./Payment";
import {
  getValuesAddonPayments,
  getValuesAdyen,
  getValuesCheckoutPNP,
  getValuesCriptan,
  getValuesFreedomPay,
  getValuesNemuru,
  getValuesPaycomet,
  getValuesPaycometIvr,
  getValuesPaypal,
  getValuesPNPPROXY,
  getValuesPNPVersion2,
  getValuesPnpSdk,
  getValuesReservationRequest,
  getValuesSepteoVault,
  getValuesSepteoPayments,
  getValuesStripe,
  getValuesTCGarantia,
  getValuesTPV,
  getValuesTransfer,
  getValuesWithoutCard,
  getValuesSiPay,
} from "./ValuesPayments";

const messages = defineMessages({
  add: {
    id: "createNewPaymentType.add",
    defaultMessage: "Agregar",
  },
  type: {
    id: "createNewPaymentType.type",
    defaultMessage: "Crear nuevo",
  },
  select: {
    id: "createNewPaymentType.select",
    defaultMessage: "Seleccione",
  },
  titleSucces: {
    id: "createNewPaymentType.titleSuccess",
    defaultMessage: "Éxito",
  },
  messageSucces: {
    id: "createNewPaymentType.messageSuccess",
    defaultMessage: "Operación realizada con éxito",
  },
  titleError: {
    id: "createNewPaymentType.titleError",
    defaultMessage: "Error",
  },
  messageError: {
    id: "createNewPaymentType.messageError",
    defaultMessage: "La operación no se pudo realizar correctamente",
  },
});

const TitleStyled = styled.h3`
  width: 100vw;
  margin: -20px;
  padding: 20px;
  color: #929292;
  font-weight: normal;
  background-color: #fafbfc;
  border-bottom: 1px solid #cfdbe2;
`;

const ContainerSelectStyled = styled.div`
  max-width: 250px;
`;

const StyledButton = styled(Button)`
  margin-right: 15px;
`;

interface Props {
  optionsTickerHave: Payment[];
  propertyTicker: string;
  onNewPayment: () => void;
}

type dataOptionsType = {
  [key: string]: {
    label: string;
  };
};

const optPayments = {
  criptan: {
    label: "CRIPTAN",
    idFromAPI: "CRIPTAN",
  },
  pnpProxy: {
    label: "PNP_PROXY",
    idFromAPI: "pay_no_pain_proxy",
  },
  pnpProxyVersion2: {
    label: "PNP_V3",
    idFromAPI: "pay_no_pain_v2",
  },
  withoutCard: {
    label: "WITHOUT_CARD",
    idFromAPI: "without_card",
  },
  reservationRequest: {
    label: "RESERVATION_REQUEST",
    idFromAPI: "reservation_request",
  },
  payPal: {
    label: "paypal",
    idFromAPI: "paypal_ec",
  },
  TCG: {
    label: "TCG",
    idFromAPI: "tcgarantia",
  },
  TPV: {
    label: "TPV",
    idFromAPI: "tpv",
  },
  transfer: {
    label: "transfer",
    idFromAPI: "tr",
  },
  CHECKOUT_PNP: {
    label: "CHECKOUT_PNP",
    idFromAPI: "checkout_pnp",
  },
  PAYCOMET: {
    label: "PAYCOMET",
    idFromAPI: "paycomet",
  },
  PAYCOMET_IVR: {
    label: "PAYCOMET_IVR",
    idFromAPI: "paycomet_ivr",
  },
  ADDON_PAYMENTS: {
    label: "ADDON_PAYMENTS",
    idFromAPI: "addon_payments",
  },
  ADYEN: {
    label: "ADYEN",
    idFromAPI: "adyen",
  },
  STRIPE: {
    label: "STRIPE",
    idFromAPI: "stripe",
  },
  FREEDOM_PAY: {
    label: "FREEDOM_PAY",
    idFromAPI: "freedom_pay",
  },
  NEMURU: {
    label: "NEMURU",
    idFromAPI: "nemuru",
  },
  SEPTEO_VAULT: {
    label: "SEPTEO_VAULT",
    idFromAPI: "septeo_vault",
  },
  SEPTEO_PAYMENTS: {
    label: "SEPTEO_PAYMENTS",
    idFromAPI: "septeo_payments",
  },
  SIPAY: {
    label: "SIPAY",
    idFromAPI: "sipay",
  },
  PNP_SDK: {
    label: "PNP_SDK",
    idFromAPI: "pnp_sdk",
  },
};

const FormCreateNewPaymentType = ({ optionsTickerHave, propertyTicker, onNewPayment }: Props) => {
  const intl = useIntl();

  const [dataOptions, setDataOptions] = useState({});
  const [opcSelected, setOptSelected] = useState(intl.formatMessage(messages.select));

  const user = useUserAuthInfo();
  const httpClient = useApiClient();
  const isAdmin =
    user?.isWitAdmin || user?.isCampingAdmin || user?.isCampingFrAdmin || user?.isAciAdmin;

  const handleClick = useCallback(async () => {
    if (opcSelected === intl.formatMessage(messages.select)) {
      return;
    }
    let optValues: Payment;
    switch (opcSelected) {
      case optPayments.pnpProxy.label:
        optValues = getValuesPNPPROXY(propertyTicker);
        break;
      case optPayments.pnpProxyVersion2.label:
        optValues = getValuesPNPVersion2(propertyTicker);
        break;
      case optPayments.withoutCard.label:
        optValues = getValuesWithoutCard(propertyTicker);
        break;
      case optPayments.reservationRequest.label:
        optValues = getValuesReservationRequest(propertyTicker);
        break;
      case optPayments.transfer.label:
        optValues = getValuesTransfer(propertyTicker);
        break;
      case optPayments.TPV.label:
        optValues = getValuesTPV(propertyTicker);
        break;
      case optPayments.TCG.label:
        optValues = getValuesTCGarantia(propertyTicker);
        break;
      case optPayments.payPal.label:
        optValues = getValuesPaypal(propertyTicker);
        break;
      case optPayments.criptan.label:
        optValues = getValuesCriptan(propertyTicker);
        break;
      case optPayments.CHECKOUT_PNP.label:
        optValues = getValuesCheckoutPNP(propertyTicker);
        break;
      case optPayments.PAYCOMET.label:
        optValues = getValuesPaycomet(propertyTicker);
        break;
      case optPayments.PAYCOMET_IVR.label:
        optValues = getValuesPaycometIvr(propertyTicker);
        break;
      case optPayments.ADDON_PAYMENTS.label:
        optValues = getValuesAddonPayments(propertyTicker);
        break;
      case optPayments.ADYEN.label:
        optValues = getValuesAdyen(propertyTicker);
        break;
      case optPayments.STRIPE.label:
        const existingStripePayment = optionsTickerHave.find(
          option => option.type === optPayments.STRIPE.label
        );
        optValues = getValuesStripe(propertyTicker, existingStripePayment);
        break;
      case optPayments.FREEDOM_PAY.label:
        optValues = getValuesFreedomPay(propertyTicker);
        break;
      case optPayments.NEMURU.label:
        optValues = getValuesNemuru(propertyTicker);
        break;
      case optPayments.SEPTEO_VAULT.label:
        optValues = getValuesSepteoVault(propertyTicker);
        break;
      case optPayments.SEPTEO_PAYMENTS.label:
        optValues = getValuesSepteoPayments(propertyTicker);
        break;
      case optPayments.SIPAY.label:
        optValues = getValuesSiPay(propertyTicker);
        break;
      case optPayments.PNP_SDK.label: {
        const existingPnpSdkPayment = optionsTickerHave.find(
          option => option.type === optPayments.PNP_SDK.label
        );
        optValues = getValuesPnpSdk(propertyTicker, existingPnpSdkPayment);
        break;
      }
      default:
        throw new Error("Invalid payment type");
    }

    try {
      const data = await httpClient.post<Payment, Payment>(
        `/api/backoffice/${propertyTicker}/payments`,
        optValues
      );

      if (data?.id) {
        await swal(
          intl.formatMessage(messages.titleSucces),
          intl.formatMessage(messages.messageSucces),
          "success"
        );
        onNewPayment();
      } else {
        swal(
          intl.formatMessage(messages.titleError),
          intl.formatMessage(messages.messageError),
          "error"
        );
      }
    } catch (error) {
      swal(
        intl.formatMessage(messages.titleError),
        intl.formatMessage(messages.messageError),
        "error"
      );
    }
  }, [opcSelected, intl, propertyTicker, optionsTickerHave, httpClient, onNewPayment]);

  useEffect(() => {
    if (optionsTickerHave) {
      const hasPnpProxy = optionsTickerHave.some(
        option => option.ticker === optPayments.pnpProxy.idFromAPI
      );
      const hasPnpVersion2 = optionsTickerHave.some(
        option => option.ticker === optPayments.pnpProxyVersion2.idFromAPI
      );
      const hasWithoutCard = optionsTickerHave.some(
        option => option.ticker === optPayments.withoutCard.idFromAPI
      );
      const hasReservationRequest = optionsTickerHave.some(
        option => option.ticker === optPayments.reservationRequest.idFromAPI
      );
      const hasPayPal = optionsTickerHave.some(
        option => option.ticker === optPayments.payPal.idFromAPI
      );
      const hasTransfer = optionsTickerHave.some(
        option => option.ticker === optPayments.transfer.idFromAPI
      );
      const hasCriptan = optionsTickerHave.some(
        option => option.ticker === optPayments.criptan.idFromAPI
      );
      const hasPaycometIvr = optionsTickerHave.some(
        option => option.type === optPayments.PAYCOMET_IVR.label
      );
      const hasNemuru = optionsTickerHave.some(option => option.type === optPayments.NEMURU.label);

      const newDataOptions: dataOptionsType = {
        [intl.formatMessage(messages.select)]: {
          label: intl.formatMessage(messages.select),
        },
      };

      if (!hasPayPal) {
        newDataOptions[optPayments.payPal.label] = {
          label: optPayments.payPal.label,
        };
      }
      if (!hasTransfer) {
        newDataOptions[optPayments.transfer.label] = {
          label: optPayments.transfer.label,
        };
      }
      if (!hasCriptan) {
        newDataOptions[optPayments.criptan.label] = {
          label: optPayments.criptan.label,
        };
      }
      if (!hasPnpProxy) {
        newDataOptions[optPayments.pnpProxy.label] = {
          label: optPayments.pnpProxy.label,
        };
      }
      if (!hasPnpVersion2) {
        newDataOptions[optPayments.pnpProxyVersion2.label] = {
          label: optPayments.pnpProxyVersion2.label,
        };
      }
      if (!hasWithoutCard) {
        newDataOptions[optPayments.withoutCard.label] = {
          label: optPayments.withoutCard.label,
        };
      }
      if (!hasReservationRequest) {
        newDataOptions[optPayments.reservationRequest.label] = {
          label: optPayments.reservationRequest.label,
        };
      }
      if (!hasPaycometIvr) {
        newDataOptions[optPayments.PAYCOMET_IVR.label] = {
          label: optPayments.PAYCOMET_IVR.label,
        };
      }
      if (!hasNemuru) {
        newDataOptions[optPayments.NEMURU.label] = {
          label: optPayments.NEMURU.label,
        };
      }

      newDataOptions[optPayments.TPV.label] = {
        label: optPayments.TPV.label,
      };
      newDataOptions[optPayments.CHECKOUT_PNP.label] = {
        label: optPayments.CHECKOUT_PNP.label,
      };
      newDataOptions[optPayments.PAYCOMET.label] = {
        label: optPayments.PAYCOMET.label,
      };
      newDataOptions[optPayments.ADDON_PAYMENTS.label] = {
        label: optPayments.ADDON_PAYMENTS.label,
      };
      newDataOptions[optPayments.ADYEN.label] = {
        label: optPayments.ADYEN.label,
      };
      newDataOptions[optPayments.STRIPE.label] = {
        label: optPayments.STRIPE.label,
      };
      newDataOptions[optPayments.FREEDOM_PAY.label] = {
        label: optPayments.FREEDOM_PAY.label,
      };
      newDataOptions[optPayments.SEPTEO_VAULT.label] = {
        label: optPayments.SEPTEO_VAULT.label,
      };
      newDataOptions[optPayments.SEPTEO_PAYMENTS.label] = {
        label: optPayments.SEPTEO_PAYMENTS.label,
      };
      newDataOptions[optPayments.SIPAY.label] = {
        label: optPayments.SIPAY.label,
      };
      newDataOptions[optPayments.PNP_SDK.label] = {
        label: optPayments.PNP_SDK.label,
      };
      setDataOptions(newDataOptions);
    }
    return () => {
      setDataOptions({});
    };
  }, [intl, optionsTickerHave]);

  if (!isAdmin) {
    return null;
  }

  return (
    <ContentWrapper>
      <TitleStyled>
        <FormattedMessage {...messages.type} />
      </TitleStyled>
      <ContainerSelectStyled>
        <SelectGroup
          value={opcSelected}
          field={{
            fieldName: "type",
            widget: "selector",
            optionDisplay: dataOptions,
          }}
          onChange={({ event }) => setOptSelected(event.target.value)}
          errors={undefined}
          additionalFields={undefined}
          className={undefined}
        />
      </ContainerSelectStyled>
      <StyledButton variant="primary" type="button" onClick={handleClick}>
        <FormattedMessage {...messages.add} />
      </StyledButton>
    </ContentWrapper>
  );
};

export default FormCreateNewPaymentType;
